"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserSession = /** @class */ (function () {
    function UserSession(idToken, accessToken, language, refreshToken) {
        this.idToken = idToken;
        this.accessToken = accessToken;
        this.language = language;
        this.refreshToken = refreshToken;
        this.localClockDiff = this.calculateLocalClockDiff();
    }
    UserSession.prototype.isValid = function () {
        var date = new Date();
        var now = Math.floor(date.getTime() / 1000);
        var adjusted = now - this.localClockDiff;
        return this.accessToken && adjusted < this.accessToken.expiration;
    };
    UserSession.prototype.calculateLocalClockDiff = function () {
        return 0;
    };
    return UserSession;
}());
exports.default = UserSession;
//# sourceMappingURL=user.session.js.map